<template>
  <div>
    <div v-if="ufs && ufs.length > 0">
      <b-tabs active-nav-item-class="font-weight-bold">
        <b-tab :active="estado.uf == active_uf" v-for="(estado, index) in ufs" :key="index" lazy>
          <template #title>
            {{ estado.uf }}
            <b-badge variant="danger" v-if="estado && estado.total_notificacoes">{{ estado.total_notificacoes }}
            </b-badge>
          </template>
          <slot v-bind:uf="estado.uf"></slot>
        </b-tab>
      </b-tabs>
    </div>

    <b-alert show variant="warning" no-body v-else-if="ready">
      <h5 class="alert-heading">Olá {{ user.name }},</h5>
      <p>
        Clique no botão "+ Adicionar novo" para cadastrar e começar a acompanhar os vencimentos.
      </p>

    </b-alert>

  </div>
</template>
<script>
import axios from "axios";
import { mapState } from 'vuex';
export default {
  data() {
    return {
      active_uf: 0,
      estados: Array,
      ready: false,
      ufs: []
    };
  },
  props: {
    route: { type: String, required: true },
  },
  computed: {
    ...mapState('user', [
      'user',
      'parceiro'
    ]),
    ...mapState('loading', [
      'loading'
    ])
  },
  created() {

    if (this.route) {
      this.getUfs();
    }


    let uf = new URLSearchParams(window.location.search).get("uf");

    if (!uf) {

      uf = this.parceiro.user_uf;

    }


    if (uf) this.active_uf = uf;
  },
  

  methods: {
    async getUfs() {
      const result = await this.$api.get(this.route);
      this.ufs = result.data;
      this.ready = true;
    },
    // async getEstados() {
    //   let result = await axios.post("/estados", { ufs: this.ufs });
    //   this.estados = result.data;

    //   let uf = new URLSearchParams(window.location.search).get("uf");

    //   if (uf) {
    //     this.active_uf = uf;
    //   } else {
    //     this.active_uf = this.estados[0].estado_sigla;
    //   }
    // },
  },
};
</script>

